import styled from "styled-components";
import useRankingView from "features/homework/hooks/useRankingView";
import { useState } from "react";

function RankingView(){
    const [selectedMonth, setSelectedMonth] = useState<number>(new Date().getMonth() + 1);
    const {rankingList, isLoading, updateScore} = useRankingView(selectedMonth);
    const [search, setSearch] = useState("");
    const [selectedStudent, setSelectedStudent] = useState<{id: string, name: string, score: number} | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const currentUid = localStorage.getItem('uid') || '';
    
    const myIndex = rankingList.findIndex(item => item.id === currentUid);
    const myRank = myIndex >= 0 ? myIndex + 1 : null;
    const myUser = myIndex >= 0 ? rankingList[myIndex] : null;

    const filteredList = search.trim() === ""
        ? rankingList
        : rankingList.filter(item => (item.name || "").toLowerCase().includes(search.trim().toLowerCase()));

    const showPodium = search.trim() === "";
    const first = showPodium ? filteredList.find(item => item.rank === 1) : undefined;
    const second = showPodium ? filteredList.find(item => item.rank === 2) : undefined;
    const third = showPodium ? filteredList.find(item => item.rank === 3) : undefined;
    const restList = showPodium ? filteredList.filter(item => item.rank > 3) : filteredList;

    const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedMonth(Number(e.target.value));
    };

    const handleCardClick = (student: {id: string, name: string, score: number}) => {
        setSelectedStudent(student);
        setIsModalOpen(true);
    };

    const handleScoreChange = async (change: number) => {
        if (!selectedStudent) return;
        
        const success = await updateScore(selectedStudent.id, change);
        if (success) {
            setIsModalOpen(false);
            setShowSuccessModal(true);
            setTimeout(() => setShowSuccessModal(false), 1500);
        } else {
            alert('점수 수정에 실패했습니다.');
        }
    };

    const renderRankItem = (item: typeof filteredList[number]) => (
        <RankRow
            key={item.id}
            $isMe={item.id === currentUid}
            onClick={() => handleCardClick(item)}
        >
            <RankBadge $rank={item.rank}>
                {item.rank === 1 ? "🥇" : item.rank === 2 ? "🥈" : item.rank === 3 ? "🥉" : item.rank}
            </RankBadge>
            <RankName $isMe={item.id === currentUid}>{item.name || "-"}</RankName>
            <ScoreBadge score={item.score}>누적 {item.score}점</ScoreBadge>
        </RankRow>
    );

    return(
        <Container>
            <Toolbar>
                <PageHeader>
                    <PageTitle>랭킹 조회</PageTitle>
                    <PageDesc>월별 누적 점수를 확인하고, 카드를 눌러 점수를 조정할 수 있습니다.</PageDesc>
                </PageHeader>
                <ToolbarRight>
                    <MonthSelect value={selectedMonth} onChange={handleMonthChange}>
                        <option value={new Date().getMonth() + 1}>{new Date().getMonth() + 1}월</option>
                        <option value={new Date().getMonth() || 12}>{new Date().getMonth() || 12}월</option>
                    </MonthSelect>
                    <SearchInput
                        type="text"
                        placeholder="학생 이름으로 검색"
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                </ToolbarRight>
            </Toolbar>
            <ScrollBody>
            {isLoading ? (
                <LoadingWrap>
                    <Spinner />
                    <div>랭킹을 불러오는 중입니다</div>
                </LoadingWrap>
            ) : rankingList.length === 0 ? (
                <EmptyMsg>
                    <EmptyTitle>아직 랭킹이 없습니다</EmptyTitle>
                    <SubMsg>과제를 완료하면 월별 랭킹이 표시됩니다</SubMsg>
                </EmptyMsg>
            ) : filteredList.length === 0 ? (
                <EmptyMsg>
                    <EmptyTitle>검색 결과가 없습니다</EmptyTitle>
                    <SubMsg>다른 이름으로 다시 검색해 보세요</SubMsg>
                </EmptyMsg>
            ) : (
                <>
                    {myUser && search.trim() === "" && (
                        <MyRankCard>
                            <MyRankBadge>내 랭킹</MyRankBadge>
                            <MyRankInfo>
                                <MyRankNum>{myRank}</MyRankNum>
                                <MyRankName>{myUser.name || '-'}</MyRankName>
                                <ScoreBadge score={myUser.score}>누적 {myUser.score}점</ScoreBadge>
                            </MyRankInfo>
                        </MyRankCard>
                    )}
                    {showPodium && (first || second || third) && (
                        <Podium>
                            {second && (
                                <PodiumCard $rank={2} $isMe={second.id === currentUid} onClick={() => handleCardClick(second)}>
                                    <PodiumMedal>🥈</PodiumMedal>
                                    <PodiumPlace>2위</PodiumPlace>
                                    <PodiumName>{second.name || "-"}</PodiumName>
                                    <ScoreBadge score={second.score}>누적 {second.score}점</ScoreBadge>
                                </PodiumCard>
                            )}
                            {first && (
                                <PodiumCard $rank={1} $isMe={first.id === currentUid} onClick={() => handleCardClick(first)}>
                                    <PodiumMedal>🥇</PodiumMedal>
                                    <PodiumPlace>1위</PodiumPlace>
                                    <PodiumName>{first.name || "-"}</PodiumName>
                                    <ScoreBadge score={first.score}>누적 {first.score}점</ScoreBadge>
                                </PodiumCard>
                            )}
                            {third && (
                                <PodiumCard $rank={3} $isMe={third.id === currentUid} onClick={() => handleCardClick(third)}>
                                    <PodiumMedal>🥉</PodiumMedal>
                                    <PodiumPlace>3위</PodiumPlace>
                                    <PodiumName>{third.name || "-"}</PodiumName>
                                    <ScoreBadge score={third.score}>누적 {third.score}점</ScoreBadge>
                                </PodiumCard>
                            )}
                        </Podium>
                    )}
                    <RankList>
                        {restList.map((item) => renderRankItem(item))}
                    </RankList>
                </>
            )}
            </ScrollBody>

            {isModalOpen && selectedStudent && (
                <ModalOverlay onClick={() => setIsModalOpen(false)}>
                    <ModalContent onClick={e => e.stopPropagation()}>
                        <ModalHeader>
                            <ModalTitle>점수 수정</ModalTitle>
                            <StudentName>{selectedStudent.name}</StudentName>
                            <CloseButton onClick={() => setIsModalOpen(false)}>×</CloseButton>
                        </ModalHeader>
                        <ModalBody>
                            <CurrentScore>현재 점수: {selectedStudent.score}점</CurrentScore>
                            <ScoreButtons>
                                <ScoreButton $negative onClick={() => handleScoreChange(-10)}>-10</ScoreButton>
                                <ScoreButton $negative onClick={() => handleScoreChange(-5)}>-5</ScoreButton>
                                <ScoreButton onClick={() => handleScoreChange(5)}>+5</ScoreButton>
                                <ScoreButton onClick={() => handleScoreChange(10)}>+10</ScoreButton>
                            </ScoreButtons>
                        </ModalBody>
                    </ModalContent>
                </ModalOverlay>
            )}

            {showSuccessModal && (
                <SuccessModalOverlay>
                    <SuccessModalBox>변경되었습니다</SuccessModalBox>
                </SuccessModalOverlay>
            )}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    height: 100%;
    min-height: 0;
    flex: 1;
    padding: 24px 28px;
    align-items: stretch;
    background: #F8FAFC;
    overflow: hidden;
    box-sizing: border-box;
`;

const ScrollBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-bottom: 8px;

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
        background: #F1F5F9;
    }
    &::-webkit-scrollbar-thumb {
        background: #CBD5E1;
        border-radius: 3px;
    }
`;

const Toolbar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 16px;
    flex-wrap: wrap;
    flex-shrink: 0;
`;

const PageHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const PageTitle = styled.h2`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #0F172A;
    letter-spacing: -0.02em;
`;

const PageDesc = styled.p`
    margin: 0;
    font-size: 13px;
    color: #64748B;
`;

const ToolbarRight = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
`;

const MonthSelect = styled.select`
    padding: 8px 12px;
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    font-size: 13px;
    color: #0F172A;
    background: #FFFFFF;
    transition: all 0.2s;
    cursor: pointer;
    &:focus {
        outline: none;
        border-color: #DF0000;
        box-shadow: 0 0 0 3px rgba(223, 0, 0, 0.12);
    }
`;

const SearchInput = styled.input`
    width: 220px;
    padding: 8px 12px;
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    font-size: 13px;
    color: #0F172A;
    background: #FFFFFF;
    transition: all 0.2s;
    &:focus {
        outline: none;
        border-color: #DF0000;
        box-shadow: 0 0 0 3px rgba(223, 0, 0, 0.12);
    }
    &::placeholder {
        color: #94A3B8;
    }
`;

const Podium = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    align-items: end;
    flex-shrink: 0;
    @media (max-width: 800px) {
        grid-template-columns: 1fr;
    }
`;

const PodiumCard = styled.button<{ $rank: number; $isMe: boolean }>`
    appearance: none;
    border: 1px solid ${({ $isMe, $rank }) => $isMe ? "#DF0000" : $rank === 1 ? "#FDE68A" : "#E2E8F0"};
    background: ${({ $rank }) =>
        $rank === 1 ? "#FFFBEB" :
        $rank === 2 ? "#F8FAFC" :
        "#FFF7ED"};
    border-radius: 16px;
    padding: ${({ $rank }) => $rank === 1 ? "28px 20px" : "22px 20px"};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05), 0 8px 24px rgba(15, 23, 42, 0.04);
    order: ${({ $rank }) => $rank === 1 ? 2 : $rank === 2 ? 1 : 3};
    grid-column: ${({ $rank }) => $rank === 1 ? 2 : $rank === 2 ? 1 : 3};
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
    }
    @media (max-width: 800px) {
        grid-column: auto;
        order: ${({ $rank }) => $rank};
    }
`;

const PodiumMedal = styled.div`
    font-size: 32px;
    line-height: 1;
`;

const PodiumPlace = styled.div`
    font-size: 12px;
    font-weight: 700;
    color: #64748B;
`;

const PodiumName = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #0F172A;
`;

const RankList = styled.div`
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    border: 1px solid #E2E8F0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
    flex-shrink: 0;
`;

const RankRow = styled.button<{ $isMe: boolean }>`
    appearance: none;
    width: 100%;
    border: none;
    border-bottom: 1px solid #F1F5F9;
    background: ${({ $isMe }) => $isMe ? "#FEF2F2" : "#FFFFFF"};
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 20px;
    cursor: pointer;
    text-align: left;
    box-shadow: ${({ $isMe }) => $isMe ? "inset 3px 0 0 #DF0000" : "none"};
    &:last-child {
        border-bottom: none;
    }
    &:hover {
        background: ${({ $isMe }) => $isMe ? "#FEF2F2" : "#F8FAFC"};
    }
`;

const RankBadge = styled.div<{ $rank: number }>`
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${({ $rank }) => $rank <= 3 ? "18px" : "13px"};
    font-weight: 700;
    color: ${({ $rank }) => $rank <= 3 ? "#0F172A" : "#64748B"};
    background: #F8FAFC;
`;

const RankName = styled.div<{ $isMe: boolean }>`
    flex: 1;
    font-weight: 600;
    color: ${({ $isMe }) => $isMe ? "#B91C1C" : "#0F172A"};
    font-size: 14px;
`;

const ScoreBadge = styled.div<{score: number}>`
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    background: ${({score}) => score >= 90 ? "#FEF2F2" : score >= 80 ? "#FFF7ED" : "#F1F5F9"};
    color: ${({score}) => score >= 90 ? "#B91C1C" : score >= 80 ? "#C2410C" : "#475569"};
`;

const MyRankCard = styled.div`
    background: #FEF2F2;
    border: 1px solid #FECACA;
    border-radius: 16px;
    padding: 20px;
    position: relative;
`;

const MyRankBadge = styled.div`
    position: absolute;
    top: -10px;
    left: 20px;
    background: #DF0000;
    color: #FFFFFF;
    font-size: 12px;
    font-weight: 700;
    padding: 4px 12px;
    border-radius: 999px;
`;

const MyRankInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    width: 100%;
`;

const MyRankNum = styled.div`
    font-size: 24px;
    font-weight: 700;
    color: #B91C1C;
`;

const MyRankName = styled.div`
    font-weight: 600;
    color: #0F172A;
    font-size: 16px;
    flex: 1;
`;

const LoadingWrap = styled.div`
    margin: 48px 0;
    color: #DF0000;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
`;

const Spinner = styled.div`
    width: 32px;
    height: 32px;
    border: 3px solid #E2E8F0;
    border-top-color: #DF0000;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }
`;

const EmptyMsg = styled.div`
    margin: 48px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
`;

const EmptyTitle = styled.div`
    color: #0F172A;
    font-size: 16px;
    font-weight: 700;
`;

const SubMsg = styled.div`
    color: #64748B;
    font-size: 13px;
`;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background: #fff;
    border-radius: 16px;
    width: 95%;
    max-width: 420px;
    padding: 28px 28px 24px;
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.18);
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const ModalHeader = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

const ModalTitle = styled.h2`
    font-size: 18px;
    font-weight: 700;
    color: #0F172A;
    margin: 0;
`;

const StudentName = styled.div`
    font-size: 15px;
    font-weight: 700;
    color: #DF0000;
    flex: 1;
    text-align: center;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 24px;
    color: #94A3B8;
    cursor: pointer;
    padding: 4px 8px;
    line-height: 1;
    border-radius: 8px;
    &:hover {
        background: #F1F5F9;
        color: #0F172A;
    }
`;

const ModalBody = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
`;

const CurrentScore = styled.div`
    font-size: 16px;
    color: #0F172A;
    text-align: center;
    font-weight: 700;
`;

const ScoreButtons = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    width: 100%;
`;

const ScoreButton = styled.button<{ $negative?: boolean }>`
    padding: 14px 0;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    background: ${({ $negative }) => $negative ? "#64748B" : "#DF0000"};
    cursor: pointer;
    transition: background 0.15s, transform 0.12s;
    &:hover {
        background: ${({ $negative }) => $negative ? "#475569" : "#B91C1C"};
        transform: translateY(-1px);
    }
    &:active {
        transform: scale(0.98);
    }
`;

const SuccessModalOverlay = styled.div`
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(15, 23, 42, 0.15);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
`;

const SuccessModalBox = styled.div`
    background: #fff;
    border-radius: 16px;
    padding: 28px 40px;
    font-size: 16px;
    font-weight: 700;
    color: #DF0000;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
    text-align: center;
`;

export default RankingView;
